import router from '@/router'
import firebase from '@/api/firebase'
import * as authService from '@/services/auth.service'
import { Store } from '@/store/store.class'
import { store } from '@/store'
import { toast } from '@/api/tools'

interface AuthState extends Object {
    user: firebase.User | null;
    isNewUser: boolean;
    loading: boolean;
}

class AuthStore extends Store<AuthState> {
  constructor() {
    super({
      name: 'auth',
      cached: true,
      state: {
        user: null,
        loading: true,
        isNewUser: false
      }
    })
  }
  onBeforeCreate(state: AuthState) {    
    state.loading = true
    // Check for user changes
    firebase.auth().onAuthStateChanged(user => {       
      this.setUser(user)      
      this.setLoading(false)
      store.user.changeUser(user?.uid)
    })
    return state
  }

  getUserId() {
    return this.state.user?.uid
  }

  signedIn() { return Boolean(this.state.user) }
  getUser() { return this.state.user }
  userId = this.get(state => state.user?.uid)
  email = this.get(state => state.user?.email)

  setUser(user: firebase.User | null) {     
    this.mutate(state => state.user = user)   
  }
  setLoading(loading: boolean) {
    this.mutate(state => state.loading = loading)   
  }

  async signInWithGoogle(next?: Function) {
    const auth = await authService.signInWithGoogle()
    if (auth) {
      this.setUser(auth.user)
      next && next()
    }
    return
  }

  async signInWithFacebook(next?: Function) {
    const auth = await authService.signInWithFacebook()
    if (auth) {
      this.setUser(auth.user)
      next && next()
    }
    return
  }

  async signOut() {
    try {
      await authService.signOut()
      this.setUser(null)
      router.push('/')
    } catch (err) {
      toast({title: 'Sign out error', msg: err, type: 'error'})
    }
  }
}
export const authStore = new AuthStore()